import React from 'react';
import Textarea from '../../../components/ui/Textarea';
import {
  PROCESSING_FEEDBACK_MEDIA_FIELDS,
  VISUAL_OUTPUT_FEEDBACK_FIELDS,
} from '../constants';

function ProcessingFeedbackFields({ processingFeedback, onProcessingFeedbackChange }) {
  const handleMediaMessageChange = (key, value) => {
    onProcessingFeedbackChange({
      mediaMessages: {
        ...processingFeedback.mediaMessages,
        [key]: value,
      },
    });
  };

  const handleVisualOutputMessageChange = (key, value) => {
    onProcessingFeedbackChange({
      visualOutputFormatMessages: {
        ...processingFeedback.visualOutputFormatMessages,
        [key]: value,
      },
    });
  };

  return (
    <div className="space-y-4">
      <label className="flex items-center gap-2 text-sm text-content-secondary">
        <input
          type="checkbox"
          checked={processingFeedback.enabled}
          onChange={(e) => onProcessingFeedbackChange({ enabled: e.target.checked })}
        />
        Habilitar feedback durante processamento
      </label>

      {processingFeedback.enabled && (
        <>
          <label className="flex items-center gap-2 text-sm text-content-secondary">
            <input
              type="checkbox"
              checked={processingFeedback.typingForText}
              onChange={(e) =>
                onProcessingFeedbackChange({ typingForText: e.target.checked })
              }
            />
            Mostrar &quot;digitando...&quot; para mensagens de texto
          </label>

          <div>
            <p className="text-xs font-medium text-content-secondary mb-3">
              Mensagens para arquivos e mídia
            </p>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {PROCESSING_FEEDBACK_MEDIA_FIELDS.map(({ key, label }) => (
                <Textarea
                  key={key}
                  id={`processing_feedback_${key}`}
                  label={label}
                  value={processingFeedback.mediaMessages[key] || ''}
                  onChange={(e) => handleMediaMessageChange(key, e.target.value)}
                  rows={2}
                  placeholder="Mensagem enviada enquanto o arquivo é processado"
                />
              ))}
            </div>
          </div>

          <label className="flex items-center gap-2 text-sm text-content-secondary">
            <input
              type="checkbox"
              checked={processingFeedback.visualOutputEnabled}
              onChange={(e) =>
                onProcessingFeedbackChange({ visualOutputEnabled: e.target.checked })
              }
            />
            Enviar feedback ao detectar pedido de saída visual (PDF/imagem)
          </label>

          {processingFeedback.visualOutputEnabled && (
            <div>
              <p className="text-xs font-medium text-content-secondary mb-3">
                Mensagens para saída visual
              </p>
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                {VISUAL_OUTPUT_FEEDBACK_FIELDS.map(({ key, label }) => (
                  <Textarea
                    key={key}
                    id={`visual_output_feedback_${key}`}
                    label={label}
                    value={processingFeedback.visualOutputFormatMessages[key] || ''}
                    onChange={(e) =>
                      handleVisualOutputMessageChange(key, e.target.value)
                    }
                    rows={2}
                    placeholder="Mensagem enviada ao identificar pedido de arquivo visual"
                  />
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ProcessingFeedbackFields;
